import { ProgressModal } from "@/components/Elements/Feedback/ProgressModal";
import {
  InputPage1,
  InputPage2,
  InputPage3,
  ResultMain,
  ResultTop,
} from "@/features/LG/components";
import { Home } from "@/features/LG/components/Home";
import { useLogin } from "@/features/LG/routes/api/useLogin";
import Layout from "@/features/LG/routes/template";
import { Title } from "@/features/LG/routes/template/Title";
import { RealtorState } from "@/store/realtorState";
import { getToken } from "@/utils/token";
import { FC, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useRecoilState, useResetRecoilState } from "recoil";

const LGRoute: FC = () => {
  const login = useLogin();
  const [realtor, setRealtor] = useRecoilState(RealtorState);
  const resetRealtor = useResetRecoilState(RealtorState);

  // 初期化
  useEffect(() => {
    const token = getToken();
    login.fetch({ token: token }, (item) => setRealtor(item), resetRealtor);
  }, []);

  // ローディング中
  if (login.isLoading) {
    return (
      <Routes>
        <Route element={<Layout hideReturn title={<Title />} />}>
          <Route path="/*" element={<ProgressModal open={login.isLoading} />} />
        </Route>
      </Routes>
    );
  }

  // エラー
  if (login.error) {
    return (
      <Routes>
        <Route element={<Layout hideReturn title={<Title />} />}>
          <Route
            path="/*"
            element={<>お探しのページが見つかりませんでした</>}
          />
        </Route>
      </Routes>
    );
  }

  // 成功時
  return (
    <Routes>
      <Route element={<Layout hideReturn title={<Title />} />}>
        <Route path="/" element={<Home />} />
      </Route>
      <Route element={<Layout returnUrl="/" title={<Title />} />}>
        <Route path=":property_type" element={<InputPage1 next="details" />} />
      </Route>
      <Route element={<Layout title={<Title />} />}>
        <Route
          path=":property_type/details"
          element={<InputPage2 next="info" />}
        />
        <Route
          path=":property_type/info"
          element={<InputPage3 next="result" />}
        />
        <Route path="*" element={<>ユーザーが見つかりませんでした</>} />
      </Route>
      <Route element={<Layout hideReturn title={<ResultTop />} />}>
        <Route path=":property_type/result" element={<ResultMain />} />
      </Route>
    </Routes>
  );
};

export default LGRoute;
